// REMINDER: Remove this file when we completely transitioned
// to using api/authFetch.ts

import * as R from "ramda";

import { obtainAccessToken } from "./api/apollo";

const parseJSON = response => {
    return response.json();
};

const checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        const error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
};

export const getAuthorization = async () => {
    const data = await obtainAccessToken();
    const accessToken = R.path(["auth", "accessToken"], data);
    return accessToken && accessToken.raw ? `Bearer ${accessToken.raw}` : "";
};

export const authFetch = async request => {
    const auth = await getAuthorization();

    request = new Request(request, {
        credentials: "same-origin",
        headers: {
            // TODO: uncomment when docstore will accept text/csv for downloading, T10343
            //Accept: "application/json, application/pdf, image/*, text/*",
            "Content-Type": "application/json",
            ...request.headers,
            Authorization: auth,
        },
    });

    const response = await fetch(request);

    checkStatus(response);

    return response;
};

export const Fetch = async request => {
    const raw_response = await authFetch(request);
    return parseJSON(raw_response);
};
